/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LatestHotelEmailResponse
 */
export interface LatestHotelEmailResponse {
    /**
     * True iff a matching email was found in the user's inbox.
     * @type {boolean}
     * @memberof LatestHotelEmailResponse
     */
    found: boolean;
    /**
     * 
     * @type {string}
     * @memberof LatestHotelEmailResponse
     */
    sender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LatestHotelEmailResponse
     */
    subject?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof LatestHotelEmailResponse
     */
    receivedDate?: Date | null;
    /**
     * Plaintext body of the newest matching email. Null when found=false.
     * @type {string}
     * @memberof LatestHotelEmailResponse
     */
    body?: string | null;
}

/**
 * Check if a given object implements the LatestHotelEmailResponse interface.
 */
export function instanceOfLatestHotelEmailResponse(value: object): value is LatestHotelEmailResponse {
    if (!('found' in value) || value['found'] === undefined) return false;
    return true;
}

export function LatestHotelEmailResponseFromJSON(json: any): LatestHotelEmailResponse {
    return LatestHotelEmailResponseFromJSONTyped(json, false);
}

export function LatestHotelEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestHotelEmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'found': json['found'],
        'sender': json['sender'] == null ? undefined : json['sender'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'receivedDate': json['received_date'] == null ? undefined : (new Date(json['received_date'])),
        'body': json['body'] == null ? undefined : json['body'],
    };
}

export function LatestHotelEmailResponseToJSON(json: any): LatestHotelEmailResponse {
    return LatestHotelEmailResponseToJSONTyped(json, false);
}

export function LatestHotelEmailResponseToJSONTyped(value?: LatestHotelEmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'found': value['found'],
        'sender': value['sender'],
        'subject': value['subject'],
        'received_date': value['receivedDate'] == null ? value['receivedDate'] : value['receivedDate'].toISOString(),
        'body': value['body'],
    };
}

